import { FC } from 'react'

import { Box, Table, colors } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Header } from 'modules/finance/components/FinancialWorkspace/components/Table/table/Header'
import { BlurRow } from 'modules/finance/components/FinancialWorkspace/components/Table/table/Row/BlurRow'

interface Props {
  header?: React.ReactNode
  title?: string
  items: string[]
  rowChildren?: React.ReactNode
}

const generateDummyHeaders = (year: number, months: string[]) => {
  return months.map((month, index) => {
    // create a date for the *last day of the month*
    const date = new Date(Date.UTC(year, index + 1, 0, 23, 0, 0, 0))
    return {
      label: `${month} ${year}`,
      value: date.toISOString(),
    }
  })
}

const dummyHeaders = (months: string[]) => generateDummyHeaders(new Date().getFullYear(), months)

export const BlurTable: FC<Props> = ({
  header,
  items,
  rowChildren = <></>,
  title = i18n.t('finance.financial_workspace.employee_costs.table.title'),
}) => {
  const months = [
    i18n.t('common.months_list.short.jan'),
    i18n.t('common.months_list.short.feb'),
    i18n.t('common.months_list.short.mar'),
    i18n.t('common.months_list.short.apr'),
    i18n.t('common.months_list.short.may'),
    i18n.t('common.months_list.short.jun'),
    i18n.t('common.months_list.short.jul'),
    i18n.t('common.months_list.short.aug'),
    i18n.t('common.months_list.short.sep'),
    i18n.t('common.months_list.short.oct'),
    i18n.t('common.months_list.short.nov'),
    i18n.t('common.months_list.short.dec'),
  ]

  const headers = dummyHeaders(months)

  return (
    <Box paddingTop="s16">
      <Box
        border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
        borderRadius={{ all: 'abs016' }}
      >
        {header}
        <Table
          noTopRadius
          hideBorder
          autoWidth
          style={{
            borderTop: `1px solid ${colors.grey400}`,
          }}
        >
          <Table.Head>
            <Header
              title={title}
              headers={headers.map((header) => header.label)}
              totalCount={headers.length}
              isGrouped={false}
            />
          </Table.Head>
          <Table.Body>
            {items.map((item) => (
              <BlurRow key={item} title={item} rows={4} columns={headers.length}>
                {rowChildren}
              </BlurRow>
            ))}
          </Table.Body>
        </Table>
      </Box>
    </Box>
  )
}
